module.exports = __webpack_public_path__ + "media/images/ponte-817d5ad4d85249b94ee1d32677212516.png";